import { FileProps } from '../components/shared/DragAndDrop';

export class AiAgentV2 {
    private _id?: number;
    private _name: string;
    private _context: string;
    private _behavior: string;
    private _domain: string;
    private _greeting: string;
    private _behaviorName: string;
    private _lookAndFeelChat: LookAndFeelChat | null;
    private _lookAndFeelVoice: any; // Define this type as needed
    private _lookAndFeelWhatsapp: any; // Define this type as needed
    private _privacy: Privacy | null;
    private _avatar: string;
    private _mainModel: string;
    private _mainPrompt: string;
    private _createdAt: string | undefined;
    private _updatedAt: string | undefined;
    private _skills: any; // Define this type as needed

    constructor(data: Partial<AiAgentV2Data>) {
        if (data.id) {
            this._id = data.id;
        }
        this._name = data.name ?? '';
        this._context = data.context ?? '';
        this._behavior = data.behavior ?? '';
        this._domain = data.domain ?? '';
        this._greeting = data.greeting ?? '';
        this._behaviorName = data.behavior_name ?? '';
        this._lookAndFeelChat = data.look_and_feel_chat || null;
        this._lookAndFeelVoice = data.look_and_feel_voice;
        this._lookAndFeelWhatsapp = data.look_and_feel_whatsapp;
        this._privacy = data.privacy || null;
        this._avatar = data.avatar ?? '';
        this._mainModel = data.main_model ?? '';
        this._mainPrompt = data.main_prompt ?? '';
        this._createdAt = data.created_at;
        this._updatedAt = data.updated_at;
        this._skills = data.skills;
    }

    // Getters and Setters
    get id(): number | undefined {
        return this._id;
    }

    set id(value: number | undefined) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get context(): string {
        return this._context;
    }

    set context(value: string) {
        this._context = value;
    }

    get behavior(): string {
        return this._behavior;
    }

    set behavior(value: string) {
        this._behavior = value;
    }

    get domain(): string {
        return this._domain;
    }

    set domain(value: string) {
        this._domain = value;
    }

    get greeting(): string {
        return this._greeting;
    }

    public customFunction(): string {
        return '';
    }

    public getGreetingMessage(): string[] {
        if (this._greeting) {
            return [this._greeting];
        }
        return [];
    }

    public getSuggestedMessage(): string[] {
        if (this._lookAndFeelChat && this._lookAndFeelChat.suggested_message) {
            return this._lookAndFeelChat.suggested_message;
        }
        return [];
    }

    public setSuggestedMessage(array: string[]) {
        if (array && this._lookAndFeelChat?.suggested_message) {
            this._lookAndFeelChat.suggested_message = array;
        }
    }


    set greeting(value: string) {
        this._greeting = value;
    }

    get behaviorName(): string {
        return this._behaviorName;
    }

    set behaviorName(value: string) {
        this._behaviorName = value;
    }

    get lookAndFeelChat() {
        return this._lookAndFeelChat;
    }

    set lookAndFeelChat(value: LookAndFeelChat | null) {
        this._lookAndFeelChat = value;
    }

    get lookAndFeelVoice(): any { // Define this type as needed
        return this._lookAndFeelVoice;
    }

    set lookAndFeelVoice(value: any) { // Define this type as needed
        this._lookAndFeelVoice = value;
    }

    get lookAndFeelWhatsapp(): any { // Define this type as needed
        return this._lookAndFeelWhatsapp;
    }

    set lookAndFeelWhatsapp(value: any) { // Define this type as needed
        this._lookAndFeelWhatsapp = value;
    }

    get privacy(): Privacy | null {
        return this._privacy;
    }

    set privacy(value: Privacy | null) {
        this._privacy = value;
    }

    get avatar(): string {
        return this._avatar;
    }

    set avatar(value: string) {
        this._avatar = value;
    }

    get mainModel(): string {
        return this._mainModel;
    }

    set mainModel(value: string) {
        this._mainModel = value;
    }

    get mainPrompt(): string {
        return this._mainPrompt;
    }

    set mainPrompt(value: string) {
        this._mainPrompt = value;
    }

    get createdAt() {
        return this._createdAt;
    }

    set createdAt(value: string | undefined) {
        this._createdAt = value;
    }

    // get updatedAt(): string | undefined {
    //     return this._updatedAt;
    // }
    // set updatedAt(value: string) {
    //     this._updatedAt = value;
    // }

    get skills(): any { // Define this type as needed
        return this._skills;
    }

    set skills(value: any) { // Define this type as needed
        this._skills = value;
    }
}

interface LookAndFeelChat {
    suggested_message: string[];
    avatar: string;
    agent_name: string;
    background_user_color: string | null;
    text_user_color: string;
    text_agent_color: string;
    background_agent_color: string | null;
    button_color: string | null;
    circular_alignment: string | null;
    privacy_policy_url: string | null;
    extra_config: any;
}

interface Privacy {
    public: boolean;
    white_list_ips: KeyValue[];
    white_list_countries: KeyValue[] | null;
    white_list_source: KeyValue[] | null;
    black_list_ips: string[] | null;
    black_list_countries: string[] | null;
    black_list_source: string[] | null;
    authentication_type: "sms" | "mail" | "whatsapp" | "id" | null;
	authentication_config: {name: string, value: string}[];
    policies: Omit<AgentBehavior, 'id'>[];
}


export interface VectorStoreConfiguration {
    chunk_size?: number | null;
    chunk_overlap?: number | null;
    lambda_mult?: number | null;
    search_type?: string | null;
    fetch_k?: number | null;
    k?: number;
    score_threshold?: number | null;
}


const defaultVectorStoreConfiguration: VectorStoreConfiguration = {
    chunk_size: 4000,
    chunk_overlap: 50,
    lambda_mult: null,
    search_type: null,
    fetch_k: null,
    k: 4,
    score_threshold: null,
};

export type currentColumnsToReturn = {
    columnsToReturn: KeyValue[] | null | undefined;
    group: string;
};

export type KeyValue = {
    name: string;
    value: string;
}

export type ConfigFiles = {
    files?: File[]
    filesComponent?: FileProps[]
}

export interface RetrieverConfig extends ConfigFiles{
    folder?: string | null;
    file?: string | null;
    url?: string[] | null;
    db_host?: string | null;
    db_name?: string | null;
    db_password?: string | null;
    table_name?: string | null;
    columns_to_find?: KeyValue[] | null;
    columns_to_return?: KeyValue[] | null;
    model_name?: string | null;
    fields_to_find?: KeyValue[] | null;
    fields_to_return?: KeyValue[] | null;
    force?: boolean;
    vector_store?: string
    vector_store_config?: VectorStoreConfiguration;
    config_type: SkillType;

}

export interface SummarizeConfig extends ConfigFiles{
    folder?: string | null;
    file?: string | null;
    max_token_output?: string | null
    context?: string | null
    config_type?: SkillType
    action_retriever_config?: RetrieverConfig | null
}

export type SkillSentimentAnalysisConfig = {
    threshold?: number
    config_type?: SkillType
}

export interface SkillClassificationConfig  extends ConfigFiles{
    examples?: string[];
    classification_enum?: string[];
    context?: string;
    config_type?: SkillType
    action_retriever_config?: RetrieverConfig | null;
}

export type SkillDocumentAnalysisConfig = {
    summarize_config?: SummarizeConfig
    top_words?: number | null
    sentiment_config?: SkillSentimentAnalysisConfig | null
    classification_config?: SkillClassificationConfig | null
    specialized_skill?: string[] //'Tutela' | 'Contrato' | null
}

export type AgentSkillsConfig = {
    temperature?: number; // Opcional, valor por defecto 0
    output?: number; // Opcional, valor por defecto 0
    report_key?: string;
    vector_store?: string
    max_token_output?: string;
    classification_enum?: string;
    type?: 'GET' | 'POST';
    params?: KeyValue[] | null
    headers?: KeyValue[] | null
    columns_description?: KeyValue[] | null;
    action_retriever_config?: RetrieverConfig | null;
    config_type: SkillType | string
    source_file?: string
    source_type?: string
} & RetrieverConfig & SkillDocumentAnalysisConfig & SkillClassificationConfig & SkillSentimentAnalysisConfig & ConfigFiles

export enum SkillType {
    SkillRetriever = 'SkillRetriever',
    SkillStructuredRetriever = 'SkillStructuredRetriever',
    SkillUnstructuredRetriever = 'SkillUnstructuredRetriever',
    SkillSummarize = 'SkillSummarize',
    SkillClassification = 'SkillClassification',
    SkillDataAnalysis = 'SkillDataAnalysis',
    SkillSentiment = 'SkillSentiment',
    SkillRequest = 'SkillRequest',
    SkillImageAnalysis = 'SkillImageAnalysis',
    SkillContentGenerator = 'SkillContentGenerator',
    SkillDocumentAnalysis = 'SkillDocumentAnalysis',
    SkillSpeechToText= 'SkillSpeechToText'
}

export interface SkillResponse {
   description: string;
   example: string;
   id: number;
   label: string;
   language: string;
   name: SkillType; 
}

export interface ReportResponse {
    name:string;
    _KEY:string;
}

export interface AgentSkills {
    id?: number;
    skill_id?: number;
    agent_id?: number;
    name: string; // Nombre del skill
    description: string; // Descripción
    description_en?: string;
    output_format: string;
    output_component: string;
    output_format_en?: string;
    config: AgentSkillsConfig;
    domain: string; // Dominio
    model: string; // Modelo
    prompt: string; // Prompt asociado
    prompt_en?: string;
    skill_type: SkillType | string;
}

export interface AiAgentV2Data {
    id?: number;
    name: string;
    context: string;
    behavior: string;
    domain: string;
    greeting: string;
    greeting_en?: string;
    behavior_name: string;
    look_and_feel_chat: LookAndFeelChat;
    look_and_feel_voice?: { agent_name: string }; // Define this type as needed
    look_and_feel_whatsapp?: { agent_name: string }; // Define this type as needed
    privacy: Privacy;
    avatar: string;
    main_model: string;
    main_prompt: string;
    main_prompt_en?: string;
    created_at?: string;
    updated_at?: string;
    skills?: AgentSkills[]; // Define this type as needed
}

export const defaultRetrieverConfiguration = {
    folder: null,
    file: null,
    url: null,
    db_host: null,
    db_name: null,
    db_password: null,
    table_name: null,
    columns_to_find: null,
    columns_to_return: null,
    model_name: null,
    fields_to_find: null,
    fields_to_return: null,
    force: false,
    vector_store_config: defaultVectorStoreConfiguration, // Updated here
    config_type: SkillType.SkillRetriever,
};

export interface SkillUpsert extends AgentSkills {
    config: AgentSkillsConfig;
}

export interface AgentBehavior {
    id: number;
    name: string;
    behavior: string;
    language: string;
}

export class SkillClass {

    private _skill: AgentSkills;

    constructor(data: AgentSkills) {
        this._skill = data;
    }

    get skill(): AgentSkills {
        return this._skill;
    }

    set skill(value: AgentSkills) {
        this._skill = value;
    }

    private validateListConfigParams(skill: AgentSkills, name: keyof typeof this._skill.config) {

        if (skill.config[name] && (skill.config[name] as KeyValue[]).length > 0) {
            return {
                ...skill,
                config: {
                    ...skill.config,
                    [name]: (skill.config[name] as KeyValue[]).filter(param => param.name && param.value),
                },
            } as SkillUpsert;
        }

        return skill;
    }

    private validateListRetrieverConfigParams(skill: AgentSkills, name: keyof RetrieverConfig ) {

        if ((skill.config?.action_retriever_config && skill.config?.action_retriever_config[name]as KeyValue[]) && (skill.config.action_retriever_config[name] as KeyValue[]).length > 0) {
            return {
                ...skill,
                config: {
                    ...skill.config,
                    action_retriever_config: {
                        ...skill.config.action_retriever_config,
                        [name]: (skill.config.action_retriever_config[name] as KeyValue[]).filter(param => param.name && param.value),
                    },
                },
            } as SkillUpsert;
        }

        return skill;
    }

    private  deepCopyIgnoreFiles<T>(obj: T): T {
        const copyObject = (item: any): any => {
            if (item === null || typeof item !== 'object') {
                return item;
            }

            if (Array.isArray(item)) {
                return item.map(copyObject);
            }

            const copy: { [key: string]: any } = {};

            for (const key in item) {
                if (key !== 'files' && key !== 'filesComponent' && item.hasOwnProperty(key)) {
                    copy[key] = copyObject(item[key]);
                }
            }

            return copy;
        };

        return copyObject(obj);
    }

    public getSkillToUpsert() {

        let skill = Object.assign({}, { ...this._skill } as SkillUpsert)

        // if (skill.config?.files) {
        //     delete skill.config.files;
        // }
        //
        // if (skill.config?.action_retriever_config?.files) {
        //     delete skill.config.action_retriever_config.files;
        // }

        if (skill.skill_type === SkillType.SkillRetriever) {
            skill = this.validateListConfigParams(skill, 'columns_to_find') as SkillUpsert;
            skill = this.validateListConfigParams(skill, 'columns_to_return') as SkillUpsert;
            skill = this.validateListConfigParams(skill, 'fields_to_find') as SkillUpsert;
            skill = this.validateListConfigParams(skill, 'fields_to_return') as SkillUpsert;
        } else {
            if (skill.config?.action_retriever_config) {
                skill = this.validateListRetrieverConfigParams(skill, 'columns_to_find') as SkillUpsert;
                skill = this.validateListRetrieverConfigParams(skill, 'columns_to_return') as SkillUpsert;
                skill = this.validateListRetrieverConfigParams(skill, 'fields_to_find') as SkillUpsert;
                skill = this.validateListRetrieverConfigParams(skill, 'fields_to_return') as SkillUpsert;
            }
        }
        if (skill.skill_type === SkillType.SkillRequest) {
            skill = this.validateListConfigParams(skill, 'params') as SkillUpsert;
            skill = this.validateListConfigParams(skill, 'headers') as SkillUpsert;
        }

        return this.deepCopyIgnoreFiles(skill);
    }

}